import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";
const paymentGateUrl = `${CONFIG.BASE_URL}/payment-gateway/api/v1`;

export const updateRoutingProfile = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `${paymentGateUrl}/routing-profiles/update/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggleRoutingProfileStrategy = async ({ id, strategy }) => {
  try {
    const response = await axiosInstance.put(
      `${paymentGateUrl}/routing-profiles/strategy/${id}/${strategy}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const toggleRoutingProfileStatus = async ({ id, isActive }) => {
  try {
    const response = await axiosInstance.put(
      `${paymentGateUrl}/routing-profiles/status/${id}`,
      null,
      {
        params: { isActive },
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const updateRoutingStrategy = async ({ id, strategy }) => {
  try {
    const response = await axiosInstance.delete(
      `${paymentGateUrl}/routing-profiles/strategy/${id}/${strategy}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const deleteRoutingProfile = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${paymentGateUrl}/routing-profiles/delete/${id}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createRoutingProfile = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${paymentGateUrl}/routing-profiles/create`,
      data,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getRoutingProfiles = async () => {
  try {
    const response = await axiosInstance.get(
      `${paymentGateUrl}/routing-profiles/all`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const createUpdateRouteConfig = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${paymentGateUrl}/trans_route_config/sync`,
      data,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getRoutingConfig = async () => {
  try {
    const response = await axiosInstance.get(
      `${paymentGateUrl}/trans_route_config`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};
